import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {AppConfigService} from "../../services/app.config.service";

@Component({
    selector: 'rzm-header',
    templateUrl: './rzm-header.component.html',
    styleUrls: ['./rzm-header.component.scss'],
    standalone: false
})
export class RzmHeaderComponent implements OnInit {

  @Input()
  homeRoute = '/home';

  env;

  @Output()
  navigateToSettings = new EventEmitter<void>();

  constructor(private authService: AuthService, private appConfig: AppConfigService) { }

  ngOnInit() {
    this.env = this.appConfig.getEnv();
  }


  showNavigation() {
    return this.authService.isLoggedIn();
  }

  navigateBackToSettings() {
    this.navigateToSettings.emit();
  }
}
